import { ApiService } from "./ApiService"

export class PresenceService {

    static uri = '/presence';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static getActiveStatus() {
        return ApiService.get(`${this.uri}/active-status`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static getMonthlyStats({ params }) {
        return ApiService.get(`${this.uri}/monthly-stats`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static clockIn({ data }) {
        return ApiService.post(`${this.uri}/clock-in`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static clockOut({ data }) {
        return ApiService.post(`${this.uri}/clock-out`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static update({ id, data }) {
        return ApiService.put(`${this.uri}/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static destroy({ id }) {
        return ApiService.delete(`${this.uri}/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }
}